import { atom } from 'recoil'

export const isLoggedInState = atom({
  key: 'isLoggedIn',
  default: !!localStorage.getItem('authToken') // Simple check to see if there's a token
})
